import {
  GiUnderwear,
  GiDress,
  GiClothes,
  GiLargeDress
} from "react-icons/gi"
import { PiDressFill } from "react-icons/pi";

import { FaTshirt } from "react-icons/fa"

export const PLACEHOLDER_ICONS = {

  product: PiDressFill,
  collection: PiDressFill,
  category: PiDressFill,

  // 🔥 custom types (optional future)
  innerwear: PiDressFill,
  gown: PiDressFill,

  default: PiDressFill

}